/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IMFIBonusItemsDetailsEntity } from '../actions/BonusItemDataServiceEntities.g';

/**
 * MfrmNotification Input Action
 */

export class MFIbonusitemsInput implements Msdyn365.IActionInput {
    public getCacheKey = () => `mfibonusitems`;
    public getCacheObjectType = () => 'mfibonusitems';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IMFIBonusItems {
    bonusItems: IMFIBonusItemsDetailsEntity[] | undefined;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new MFIbonusitemsInput();
};

async function action(input: MFIbonusitemsInput, ctx: Msdyn365.IActionContext): Promise<IMFIBonusItemsDetailsEntity[] | undefined> {
    // tslint:disable-next-line: no-unnecessary-local-variable
    const bonusItems: IMFIBonusItemsDetailsEntity[] | undefined = [];
    return bonusItems;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IMFIBonusItemsDetailsEntity[] | undefined>>action,
    id: 'MFIbonusitems',
    input: createInput
});

